var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8puca",
    d: "M772.273 74.364h-.546v-.546A3.823 3.823 0 0 0 767.91 70a3.823 3.823 0 0 0-3.818 3.818v.546h-.546a.545.545 0 0 0-.545.545v6.546c0 .301.244.545.545.545h8.728a.545.545 0 0 0 .545-.545v-6.546a.545.545 0 0 0-.545-.545zm-7.091-.546a2.733 2.733 0 0 1 5.464 0v.546h-5.464z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-763 -70)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8puca"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3af5a25435ec336d0601aaad95418b06.svg";
export { ForwardRef as ReactComponent };